<template>
  <div class="container">
    <div class="product-item">
      <img :src="detail.image">
      <div class="product-content">{{ detail.content }}</div>
    </div>
    <router-link to="/product">&lt; Back</router-link>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    head: {
      meta: [
        { name: 'description', content: 'これは個人ポートフォリオサイトです。Vue.jsを使って作ってします。' },
        { property: 'og:title', content: 'ポートフォリオ詳細ページ' },
        { property: 'og:description', content: 'これは個人ポートフォリオサイトです。Vue.jsを使って作ってします。' },
        { property: 'og:type', content: 'article' },
        { property: 'og:url', content: 'https://example.com' },
        { property: 'og:image', content: 'https://example.com/img/og.png' },
        { name: 'twitter:card', content: 'summary' }
      ]
    },
    props: { id: Number },
    computed: {
      ...mapGetters('product', ['detail']),
    },
    watch: {
      id: {
        handler() {
          this.$store.dispatch('product/load', this.id)
        }, 
        immediate: true
      }
    },
    beforeDestroy() {
      this.$store.dispatch('product/destroy')
    }
  }
</script>

<style scoped>
  h1 {
    margin: 0 0 30px 0;
  }
  .container {
    width: 75%;
  }
  .product-item {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
  }
  .product-item img {
    width: 100%;
    object-fit: cover;
    margin: 0 auto;
    filter: drop-shadow(0 0 2px rgba(0,0,0,.3));
  }
  .product-item .product-content {
    font-size: 14px;
    text-align: justify;
    margin: 0 0 50px 0;
  }
  .back {
    font-size: 14px;
    color: #696969;
    top: 32px;
    right: 30px;
    position: fixed;
    z-index: 1;
  }
  .back .back-button a {
    color: #42b983;
    transition: .5s;
  }
  .back .back-button a:hover {
    opacity: .5;
  }
  @media screen and (max-width:768px) {
    .container {
      width: 90%;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Product.vue